import { Directive } from '@angular/core';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, MatSlideToggleDefaultOptions } from '@angular/material/slide-toggle';

const CONFIRM_TOGGLE_OPTIONS: MatSlideToggleDefaultOptions = { disableToggleValue: true };

@Directive({
  selector: 'mat-slide-toggle[appConfirmToggle]',
  providers: [{ provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: CONFIRM_TOGGLE_OPTIONS }]
})
export class ConfirmToggleDirective {}
